import { useAuth } from "@/hooks/useAuth";
import { checkoutCart } from "@/lib/cart";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
const Checkout = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onCheckout = async () => {
    if (!user) return toast.error("Please login first");
    setLoading(true);
    try {
      const orderId = await checkoutCart(user.id);
      toast.success("Order placed successfully");
      navigate(`/orders/${orderId}`);
    } finally {
      setLoading(false);
    }
  };
  return (
    <main className="container mx-auto px-4 py-10">
      <SEOHead
        title="Checkout - Bahama Marketplace"
        description="Complete your purchase securely on Bahama Marketplace. Fast, reliable shipping from trusted local sellers."
      />
      <h1 className="text-3xl font-heading font-bold mb-6">Checkout</h1>
      <p className="text-muted-foreground mb-4">This will create your order and clear your cart.</p>
      <Button onClick={onCheckout} disabled={loading}>{loading ? "Placing..." : "Place Order"}</Button>
    </main>
  );
};
export default Checkout;